$(document).ready(function() {

    $('.popup-time__content__close').click(function() {
        $('.popup-time').removeClass('active');
    });

    $('.popup-time__content__close_text').click(function() {
        $('.popup-time').removeClass('active');
    });
    
    function getCookie(cName) {
        const name = cName + "=";
        const cDecoded = decodeURIComponent(document.cookie); 
        const cArr = cDecoded.split('; ');
        let res;
        cArr.forEach(val => {
            if (val.indexOf(name) === 0) res = val.substring(name.length);
        })
        return res
    }

    function setCookie(name,value,days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }

    if(getCookie("age_confirmation") === "off" && getCookie("popup-new") === undefined) {
        setCookie("popup-new",1,1);
    }
    else if(+getCookie("popup-new") >= 3) {
        if(+getCookie("popup-new") == 3 && window.location.href.indexOf("pages/newsletter") == -1 ) {
            $('.popup-time').addClass('active');
        }
        setCookie("popup-new",4,1);
    }
    else if(+getCookie("popup-new") < 3){
        setCookie("popup-new",+getCookie("popup-new") + 1,1);
    }

});